import { AdapterUi } from "@core/store/adapters/global.adapter";
import { createAction, props } from "@ngrx/store";

// Interfaces
import { PermissionGroup } from "@core/entities";
import { AuthState, LoginFormData, PasswordResetBody, RetailerInfo, TWOFACTOR_TYPE } from "@modules/auth/entities";

export enum LoginActions {
  ClearAll = "[Login] Clear store",
  Empty = "[Login] Empty",
  UiAuth = "[AUTH] Ui Auth",

  BasicLogin = "[AUTH] Basic Login",
  TwoFactorLogin = "[AUTH] TwoFactor Token Login",
  SetupTwoFactorAuthentication = "[AUTH] Setup TwoFactor Authentication",
  SetupAdditionalTwoFactorAuthentication = "[AUTH] Setup Additional TwoFactor Authentication",
  TurnOnAdditionalTwoFactorAuthentication = "[AUTH] TurnOn Additional TwoFactor Authentication",
  TurnOnTwoFactorAuthentication = "[AUTH] Turn On TwoFactor Authentication",
  RequestPhoneOTP = "[AUTH] Request Phone OTP",
  ValidateTwoFactor = "[AUTH] Validate TwoFactor",
  SetTwoFactorData = "[AUTH] Set Two Factor Data",
  ListTwoFactorConfigs = "[AUTH] List Two Factor Configs",
  DeleteConfig = "[AUTH] Delete config",
  WipeTwoFactorData = "[AUTH] Wipe Two Factor Data",
  Fetch2FADeadline = "[AUTH] Fetch 2FA Deadline",

  RespSuccess = "[Login] Response Login Request",
  ExchangeRequest = "[AUTH] Exchange Request",
  CreateRetailer = "[AUTH] Create Retailer",
  GoLogin = "[AUTH] Go Login",
  SetAppUserId = "[AUTH] Set Application User Id",
  FetchRetailerIds = "[AUTH] Fetch Retailer Ids",
  PasswordReset = "[AUTH] Password Reset",
  RequestPasswordReset = "[AUTH] Request Password Reset",
  ExternalTokenLogin = "[AUTH] External token login ",
}

export const clearAll = createAction(LoginActions.ClearAll);
export const empty = createAction(LoginActions.Empty);
export const uiAuth = createAction(LoginActions.UiAuth, props<{ ui: Array<AdapterUi<AuthState["ui"]>> }>());

export const basicLogin = createAction(LoginActions.BasicLogin, props<{ formdata: LoginFormData }>());
export const twoFactorLogin = createAction(
  LoginActions.TwoFactorLogin,
  props<{ access_token: string; two_factor_authentication_code: string; twofactortype: TWOFACTOR_TYPE; fullHash?: string; id: number }>()
);

export const listTwoFactorConfigs = createAction(LoginActions.ListTwoFactorConfigs);
export const setupTwoFactorAuthentication = createAction(
  LoginActions.SetupTwoFactorAuthentication,
  props<{ method: TWOFACTOR_TYPE; phone?: string; accessToken: string; nickname?: string }>()
);
export const turnOnTwoFactorAuthentication = createAction(
  LoginActions.TurnOnTwoFactorAuthentication,
  props<{ method: TWOFACTOR_TYPE; accessToken: string; otp: string; fullHash?: string; id: number }>()
);

export const setupAdditionalTwoFactorAuthentication = createAction(
  LoginActions.SetupAdditionalTwoFactorAuthentication,
  props<{ method: TWOFACTOR_TYPE; phone?: string; nickname?: string }>()
);
export const turnOnAdditionalTwoFactorAuthentication = createAction(
  LoginActions.TurnOnAdditionalTwoFactorAuthentication,
  props<{ method: TWOFACTOR_TYPE; otp: string; fullHash?: string; authenticatorId?: number }>()
);

export const requestPhoneOTP = createAction(LoginActions.ValidateTwoFactor, props<{ id: number; accessToken: string }>());
export const validateTwoFactor = createAction(LoginActions.ValidateTwoFactor, props<{ accessToken: string }>());
export const setTwoFactorData = createAction(LoginActions.SetTwoFactorData, props<{ twofa: Partial<AuthState["twofa"]> }>());

export const wipeTwoFactorData = createAction(LoginActions.WipeTwoFactorData);
export const deleteConfig = createAction(LoginActions.DeleteConfig, props<{ configId: number }>());

export const respSuccessAction = createAction(
  LoginActions.RespSuccess,
  props<{
    payload: {
      auth: { access_token: string };
      permissionGroup: PermissionGroup;
      redirect: boolean;
    };
  }>()
);
export const exchangeRequest = createAction(LoginActions.ExchangeRequest, props<{ code: string }>());
export const createRetailer = createAction(LoginActions.CreateRetailer, props<{ payload: RetailerInfo }>());
export const setAppUserId = createAction(LoginActions.SetAppUserId, props<{ payload: number }>());
export const fetchRetailerIds = createAction(LoginActions.FetchRetailerIds, props<{ resp: { access_token: string } }>());
export const passwordReset = createAction(LoginActions.PasswordReset, props<{ payload: PasswordResetBody }>());
export const requestPasswordReset = createAction(LoginActions.RequestPasswordReset, props<{ email: string }>());
export const goLogin = createAction(LoginActions.GoLogin);
export const externalTokenLogin = createAction(LoginActions.ExternalTokenLogin, props<{ access_token: string }>());
export const fetch2FADeadline = createAction(LoginActions.Fetch2FADeadline);
